import { useState } from "react";
import VerseRow from "./verserow";
import { Plus } from "lucide-react";

const isValidYouTubeUrl = (url) => {
  const regex =
    /^(https?:\/\/)?(www\.)?(youtube\.com\/(watch\?v=|embed\/|shorts\/)|youtu\.be\/)[\w-]{11}(\?.*)?$/;
  return regex.test(url);
};


const PlanCard = ({ plan, onChange, onAddVerse }) => {
  const [videoError, setVideoError] = useState("");

  const handleVideoChange = (e) => {
    const value = e.target.value;

    if (value && !isValidYouTubeUrl(value)) {
      setVideoError("Please enter a valid YouTube URL");
    } else {
      setVideoError("");
    }

    onChange({
      ...plan,
      youtubeUrl: value,
    });
  };

  return (
    <div className="rounded-xl p-4 min-w-[280px] max-w-[300px] flex-shrink-0 bg-[#1f1f1f]">
      {/* Title + Day */}
      <div className="flex justify-between items-center mb-3 border-b border-[#2f2f2f] pb-1">
        <input
          type="text"
          placeholder="Plan Title"
          value={plan.title}
          onChange={(e) => onChange({ ...plan, title: e.target.value })}
          className="bg-transparent text-[#F8BA34] font-semibold focus:outline-none w-[70%]"
        />
        <span className="text-[#F8BA34] font-semibold">Day {plan.day}</span>
      </div>

      {/* Description */}
      <textarea
        placeholder="Write your devotional..."
        value={plan.description}
        onChange={(e) =>
          onChange({ ...plan, description: e.target.value })
        }
        className="bg-[#2a2a2a] text-[#A3A3A3] rounded-md p-3 text-sm mb-4 w-full resize-none h-[90px] focus:outline-none"
      />

      {/* Verses */}
      <div className="space-y-3">
        {plan.verses.map((verse, idx) => (
          <VerseRow key={idx} verse={verse} />
        ))}

        {/* Add Verse */}
        <div className="flex justify-between items-center">
          <span
            className="flex items-center gap-2 text-[#A3A3A3] cursor-pointer"
            onClick={onAddVerse}
          >
            <Plus className="w-4 h-4 border rounded-full border-[#a3a3a3]" />
            Add Verse
          </span>
        </div>

        {/* YouTube Video Input */}
        <div className="flex flex-col gap-1">
          <label className="text-[#A3A3A3] text-sm">
            YouTube Video Link
          </label>

          <input
            type="text"
            placeholder="https://www.youtube.com/watch?v=xxxx"
            value={plan.youtubeUrl || ""}
            onChange={handleVideoChange}
            className={`bg-[#2a2a2a] text-[#A3A3A3] rounded-md p-2 text-sm focus:outline-none
              ${videoError ? "border border-red-500" : "border border-transparent"}
            `}
          />

          {videoError && (
            <p className="text-xs text-red-500">{videoError}</p>
          )}
        </div>
      </div>
    </div>
  );
};

export default PlanCard;
